import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Breadcrumb — Fil d'ariane vendor
 *
 * Props:
 *   items: [{ label, href? }]
 *     - Le dernier item représente la page courante (pas de href, mis en violet).
 *     - Les items avec href sont cliquables.
 *     - Les items sans href au milieu sont du texte brut (rare).
 *
 * Usage:
 *   <Breadcrumb items={[
 *     { label: "Pilotage", href: "/vendor/pilotage" },
 *     { label: "Réservations", href: "/vendor/pilotage?tab=bookings" },
 *     { label: "Réservation #ABC123" },
 *   ]} />
 */
export default function Breadcrumb({ items = [], className = "" }) {
  if (!items.length) return null;
  return (
    <nav
      aria-label="Fil d'ariane"
      className={`flex items-center gap-1.5 text-sm ${className}`}
      data-testid="breadcrumb"
    >
      {items.map((it, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <React.Fragment key={idx}>
            {isLast ? (
              <span
                className="font-medium text-violet-600"
                data-testid="breadcrumb-current"
                aria-current="page"
              >
                {it.label}
              </span>
            ) : it.href ? (
              <Link
                to={it.href}
                className="text-slate-500 hover:text-slate-900 transition-colors"
                data-testid={`breadcrumb-link-${idx}`}
              >
                {it.label}
              </Link>
            ) : (
              <span className="text-slate-500">{it.label}</span>
            )}
            {!isLast && (
              <ChevronRight className="h-3.5 w-3.5 text-slate-300 shrink-0" />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
